import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { IconNavigationArrowRightCircle } from 'nicollet-icons-react';
import { BaseButton } from '../BaseButton/index.js';

const DIRECTIONS = {
  previous: '180deg',
  next: '0',
  up: '-90deg',
  down: '90deg',
  default: '0'
};
const SIZES = {
  sm: '20px',
  md: '32px'
};
const StyledButton = styled(BaseButton)`
  display: inline-flex;
  ${({
  rotation
}) => `transform: rotate(${rotation})`};
  padding: 0;
  border: none;
  border-radius: 50%;
  height: auto;

  :focus {
    /* override the global button:focus outline */
    outline: none;
  }

  /* use the custom icon outline instead */
  :focus,
  :active {
    g > path:nth-child(2) {
      opacity: 1;
    }
  }
`;

const ButtonWithArrow = ({
  ariaLabel = {
    paginationTitle: 'page',
    containerTitle: 'elements'
  },
  className,
  direction = 'next',
  onClick,
  size = 'md',
  ...restProps
}) => {
  var _a;

  const rotation = (_a = DIRECTIONS[direction]) !== null && _a !== void 0 ? _a : DIRECTIONS.default;
  const {
    paginationTitle,
    containerTitle
  } = ariaLabel;
  return jsx(StyledButton, Object.assign({
    "aria-label": `${direction} ${paginationTitle} of ${containerTitle}`,
    className: className,
    onClick: onClick,
    rotation: rotation,
    size: size
  }, restProps, {
    children: jsx(IconNavigationArrowRightCircle, {
      size: SIZES[size]
    }, void 0)
  }), void 0);
};

ButtonWithArrow.displayName = 'ButtonWithArrow';

export { ButtonWithArrow };
